import React from "react";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    InfoCircleOutlined,
    TeamOutlined,
    BankOutlined,
    RocketOutlined
} from "@ant-design/icons";
import { Col, Row } from "antd";
import CommonCard from "../../../global/card";
import { cn } from "../../../../utils/cn";
import { formatDateTime, formatLeadSource } from "../../../../utils/functions";

const EnhancedLeadsSentDetails = ({
    leadDetail
}) => {
    if (!leadDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            Name: <UserOutlined />,
            Email: <MailOutlined />,
            Phone: <PhoneOutlined />,
            "Event Date": <CalendarOutlined />,
            "Guest Count": <TeamOutlined />,
            Company: <BankOutlined />,
            "Imported At": <CalendarOutlined />,
            Source: <InfoCircleOutlined />,
            Destination: <RocketOutlined />
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    const { LeadsInformation } = leadDetail;

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard
                title={
                    <div className="flex items-center gap-2">
                        <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>Lead Details</span>
                    </div>
                }
            >
                <Row gutter={[24, 0]}>
                    {/* Basic Information Section */}
                    <Col span={24} className="border-b border-gray-200 py-4">
                        <div className="flex items-center gap-2 mb-4">
                            <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }} />
                            <span style={{ fontSize: "15px", fontWeight: 600 }}>Basic Information</span>
                        </div>
                        <Row gutter={[24, 16]}>
                            {[
                                {
                                    label: "Name",
                                    value: LeadsInformation?.fullName ? LeadsInformation.fullName : `${LeadsInformation?.firstName} ${LeadsInformation?.lastName}`
                                },
                                { label: "Email", value: LeadsInformation?.email },
                                { label: "Phone", value: LeadsInformation?.phone },
                                { label: "Guest Count", value: LeadsInformation?.guestCount },
                                { label: "Company", value: LeadsInformation?.company },
                                { label: "Imported At", value: formatDateTime(LeadsInformation?.createdAt) },
                                {
                                    label: "Source",
                                    value: formatLeadSource(LeadsInformation?.leadSource),
                                    className: "capitalize"
                                },
                                {
                                    label: "Destination",
                                    value: leadDetail.destinationId,
                                    className: "capitalize"
                                },
                            ].map((item) => (
                                <Col span={12} key={item.label}>
                                    <div className="flex flex-col">
                                        <span className="text-xs text-gray-500 flex items-center gap-2 mb-1">
                                            <span style={{ color: "var(--primary-color, #1890ff)" }}>
                                                {getIconForField(item.label)}
                                            </span>
                                            {item.label}
                                        </span>
                                        <span className={cn("text-sm font-semibold text-gray-900", item.className)}>{item.value || "—"}</span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedLeadsSentDetails;
